import { Button } from '@noorden-insurtech/alba-design-system';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import type { ReactNode } from 'react';

type Props = {
  onBack: () => void;
  canGoBack: boolean;
  /** Quando informado, renderiza o botão "Próximo" padrão. */
  onNext?: () => void;
  canGoNext?: boolean;
  /** Conteúdo customizado à direita (substitui o "Próximo"). */
  rightSlot?: ReactNode;
};

/**
 * Rodapé compartilhado das etapas da Proposta PME: "Voltar" à esquerda e
 * "Próximo" (ou ações customizadas) à direita.
 */
export function PmeStepFooter({
  onBack,
  canGoBack,
  onNext,
  canGoNext = true,
  rightSlot,
}: Props) {
  return (
    <div className='flex flex-row items-center justify-between gap-6 self-stretch'>
      <Button
        type='button'
        variant='ghost'
        size='lg'
        className='flex items-center gap-2'
        onClick={onBack}
        disabled={!canGoBack}
      >
        <ArrowLeft className='h-5 w-5' strokeWidth={1.6} />
        Voltar
      </Button>

      {rightSlot ?? (
        <Button
          type='button'
          variant='primary'
          size='md'
          className='flex items-center gap-2 rounded-xl px-8 py-2'
          onClick={onNext}
          disabled={!canGoNext}
        >
          Próximo
          <ArrowRight className='h-6 w-6' strokeWidth={2} />
        </Button>
      )}
    </div>
  );
}
